import { useEffect, useMemo, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { formatLocalDate } from "../../utils/formatDate";
import TelemetriaService from "../../services/resource/telemetriaService";

function TabelaTelemetria({ data, ano, mes }) {

    const telemetriaService = new TelemetriaService();
    const [loading, setLoading] = useState(true);
    const [telemetrias, setTelemetrias] = useState([]);

    const values = {
        funcionarioId: data.funcionarioId,
        ano: ano,
        mes: mes
    }
    useEffect(() => {
        telemetriaService.listar(values).then(res => {
            setTelemetrias(res.data);
        }).finally(() => setLoading(false))
    }, [])

    // meta da telemetria usada no cálculo (vem da comissão/snapshot; 98 só se não houver)
    const metaTelemetria = data.meta ?? 98;

    const formataIndice = (value) => {
        if (value >= metaTelemetria) {
            return <span className="font-bold text-teal-600">{value}</span>
        } else {
            return <span className="font-bold text-destructive">{value}</span>
        }
    }

    const medias = useMemo(() => {
        if (!telemetrias.length) {
            return {
                segurancaViaria: 0,
                manutencao: 0,
                performance: 0
            };
        }

        const soma = telemetrias.reduce((acc, item) => {
            acc.segurancaViaria += item.segurancaViaria || 0;
            acc.manutencao += item.manutencao || 0;
            acc.performance += item.performance || 0;
            return acc;
        }, {
            segurancaViaria: 0,
            manutencao: 0,
            performance: 0
        });

        return {
            segurancaViaria: (soma.segurancaViaria / telemetrias.length).toFixed(2),
            manutencao: (soma.manutencao / telemetrias.length).toFixed(2),
            performance: (soma.performance / telemetrias.length).toFixed(2)
        };
    }, [telemetrias]);

    return (
        <div>
            <DataTable
                value={telemetrias}
                loading={loading}
                scrollable
                scrollHeight="450px"
                dataKey="id"
                size="small"
                className="text-[12px] custom-datatable text-foreground border border-border cursor-default"
                rowClassName="text-[12px] border-b border-border min-w-[400px] text-foreground cursor-default"
                Menu={false}
                emptyMessage="Nenhuma carga encontrada."
                footer={() => (
                    <div className="flex justify-between items-center p-2 font-semibold text-[12px]">

                        <div>
                            Total de Telemetrias: {telemetrias.length}
                        </div>

                        <div className="flex gap-6">
                            <span>
                                Média Segurança Viária: {formataIndice(Number(medias.segurancaViaria))}
                            </span>

                            <span>
                                Média Manutenção: {formataIndice(Number(medias.manutencao))}
                            </span>

                            <span>
                                Média Performance: {formataIndice(Number(medias.performance))}
                            </span>
                        </div>

                    </div>
                )}
            >

                {/* FILIAL */}
                <Column
                    field="filialNome"
                    header="Filial"
                    sortable
                    Menu={false}
                    className="px-3"
                    style={{ minWidth: "140px" }}
                />

                <Column
                    field="funcionarioNome"
                    header="Funcionario"
                    sortable
                    Menu={false}
                    className="px-3"
                    style={{ minWidth: "140px" }}
                />

                {/* DATA */}
                <Column
                    field="data"
                    header="Data"
                    body={(row) => formatLocalDate(row.data)}
                    sortable
                    style={{ minWidth: "140px" }}
                />

                {/* CARGA */}
                <Column
                    field="segurancaViaria"
                    header="Segurança Viária"
                    sortable
                    body={row => formataIndice(row.segurancaViaria)}
                    style={{ minWidth: "140px" }}
                />

                <Column
                    field="manutencao"
                    header="Manutenção"
                    sortable
                    body={row => formataIndice(row.manutencao)}
                    style={{ minWidth: "140px" }}
                />

                {/* MOTORISTA */}
                <Column
                    field="performance"
                    header="Performance"
                    body={row => formataIndice(row.performance)}
                    sortable
                    style={{ minWidth: "200px" }}
                />

            </DataTable>
        </div>
    );
}

export default TabelaTelemetria;